<template>
  <div class="omikuji-error">
    <CampaignOmikujiHeader />
    <p class="error-text mt20">{{ errorMessage }}</p>

    <div class="error-back-button">
      <BaseBtnDetail
        :button_text="'抽選に戻る'"
        :back_color="'#007bff'"
        :text_color="'#ffffff'"
        :border_radius="'10px'"
        :border="false"
        :font_weight="'bold'"
        @handleClick="handleReturn"
      />
    </div>
  </div>
</template>

<script>
import BaseBtnDetail from "@/components/common/BaseBtnDetail";
import CampaignOmikujiHeader from "@/components/campaign/CampaignOmikujiHeader";

export default {
  components: { BaseBtnDetail, CampaignOmikujiHeader },
  props: ["errorMessage", "userId"],
  methods: {
    handleReturn() {
      this.$router.push(`/campaign/omikuji/${this.userId}`);
    }
  }
};
</script>

<style lang="css" scoped>
.omikuji-error {
  background-color: white;
  height: 100vh;
}
.error-text {
  color: red;
  padding: 10px 20px 10px 20px;
}
.error-back-button {
  padding: 30px 40px 10px 40px;
}
</style>



// WEBPACK FOOTER //
// src/views/campaign/CampaignOmikujiError.vue